import axios from "axios";
import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postFakeRegister = data => {
  return axios
    .post(url.POST_FAKE_REGISTER, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      let message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data);

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data);

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data);

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data;
      throw response.data;
    })
    .catch(err => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data);

export const getWaitList = data => get(url.GET_WAITLIST);


// get Products
export const getProducts = () => get(url.GET_PRODUCTS);

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } });

// get Events
export const getEvents = () => {
  const spaceId = localStorage.getItem('spaceId');
  return get(url.GET_EVENTS, { headers: { spaceId } });
};

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event);

// update Event
export const updateEvent = event => post(url.UPDATE_EVENT, event);

// delete Event
export const deleteEvent = event =>
  del(url.DELETE_EVENT, { headers: { event } });

//upcoming events
export const getUpcomingEvents = () => get(url.GET_UPCOMING_EVENTS);

//messages
export const getLastMessages = () => get(url.GET_LAST_MESSAGES);

//reported message
export const getReportMessages = () =>{

  const spaceId = localStorage.getItem('spaceId');
  return get(url.GET_REPORT_MESSAGES, { headers: { spaceId } });

}

  
//expense
export const getExpenseCategories = () => get(url.GET_EXPENSE_CATEGORIES);
export const addNewExpenseCategory = category => post(url.ADD_NEW_EXPENSE_CATEGORY, category);
export const updateExpenseCategory = category => put(url.UPDATE_EXPENSE_CATEGORY, category);
export const deleteExpenseCategory = category => del(url.DELETE_EXPENSE_CATEGORY, { headers: { category } });
export const getExpenses = (page = 1) =>{
  const spaceId = localStorage.getItem('spaceId');
  return get(`${url.GET_EXPENSES}?page=${page}`, { headers: { spaceId } });
}
export const addNewExpense = expense => post(url.ADD_NEW_EXPENSE, expense);
export const updateExpense = expense => post(url.UPDATE_EXPENSE, expense);
export const deleteExpense = expense => del(url.DELETE_EXPENSE, { headers: { expense } });
export const getParentsMonthlyExpense = () => get(url.GET_PARENTS_MONTHLY_EXPENSE);
export const expenceStatistics = () => {
  const spaceId = localStorage.getItem('spaceId');
  return get(url.GET_EXPENSE_STATISTICS, { headers: { spaceId } });
};

//infoBank
export const getInfoBank = () => get(url.GET_INFORMATION);
export const addInfoBankNewInformation = information => post(url.ADD_NEW_INFORMATION, information);
export const updateInfoBankInformation = information => put(url.UPDATE_INFORMATION, information);
export const deleteInfoBankInformation = id => del(`${url.DELETE_INFORMATION}/${id}`);
export const addInfoBankNewDocument = document => post(url.ADD_NEW_DOCUMENT, document);
export const updateInfoBankDocument = document => put(url.UPDATE_DOCUMENT, document);
export const deleteInfoBankDocument = document => del(url.DELETE_DOCUMENT, { headers: { document } });

//journals
export const getJournals = () => get(url.GET_JOURNALS);
export const getJournalById = (id) => get(`${url.GET_JOURNAL_BY_ID}/${id}`);
export const addNewJournal = journal => post(url.ADD_NEW_JOURNAL, journal);
export const updateJournal = journal => put(url.UPDATE_JOURNAL, journal);
export const deleteJournal = journal => del(url.DELETE_JOURNAL, { headers: { journal } });



// get Categories
export const getCategories = () => get(url.GET_CATEGORIES);

// get chats
export const getChats = () => {
  const spaceId = localStorage.getItem('spaceId');
  
  return get(url.GET_CHATS, { headers: { spaceId } });
};
 
export const getChatPolling = () => get(url.GET_CHAT_POLLING);


//moderator meesage
export const sendModeratorMessageApi = data =>{
  const spaceId = localStorage.getItem('spaceId');
  return post(url.SEND_MODERATOR_MESSAGE, data, { headers: { spaceId } });
}
// get groups
export const getGroups = () => get(url.GET_GROUPS);

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS);

// get messages
export const getMessages = (roomId = "") =>{
  const spaceId = localStorage.getItem('spaceId');
  return get(`${url.GET_MESSAGES}/${roomId}`, { headers: { spaceId } });
}

export const getSpaceDetails = (sId = "") =>{
  const spaceId = localStorage.getItem('spaceId');
  return get(`/api/spaces/get-space-by-id/${sId}`, { headers: { spaceId } });
}

export const getAdminList = () =>{
  return get("/api/admin/get-admins");
}

//add admin
export const addNewAdmin = admin => post("/api/admin/create_user", admin);

// Credit Management APIs
export const getUserCredits = () => get(url.GET_USER_CREDIT);
export const getUserCreditTransactions = () => get(url.GET_USER_CREDIT_TRANSACTIONS);
export const getAllUsersCredits = (params) => {
  let queryParams = [];
  
  if (params) {
    // Add pagination parameters
    if (params.page) {
      queryParams.push(`page=${params.page}`);
    }
    
    if (params.per_page) {
      queryParams.push(`per_page=${params.per_page}`);
    }
    
    // Add search parameter
    if (params.email) {
      queryParams.push(`email=${params.email}`);
    }
  }
  
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return get(`${url.GET_ALL_USERS_CREDITS}${queryString}`);
};
export const getUserCreditById = (userId) => get(`${url.GET_USER_CREDIT_BY_ID}/${userId}`);
export const addUserCredit = (creditData) => post(url.ADD_USER_CREDIT, creditData);
export const getUserCreditTransactionsById = (userId) => get(`${url.GET_USER_CREDIT_TRANSACTIONS_BY_ID}/${userId}`);

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message);

// get notifications
export const getNotifications = () =>
{
  const spaceId = localStorage.getItem('spaceId');
return get(url.GET_NOTIFICATIONS, { headers: { spaceId } });
}

export const getAllSpaceNotifications = () =>
{
return get(`/api/notification/get-all-space-notifications`);
}

//total customer counts
export const getTotalCustomerCounts = () =>
{
return get("/api/admin/get-total-customer-counts");
}

// get parenting space users
export const getParentingSpaceUserList = () => 
{
  const spaceId = localStorage.getItem('spaceId');
return get(url.GET_PARENTING_SPACE_USER_LIST, { headers: { spaceId } });
}

// remove space member
export const removeSpaceMember = (memberId) => {
  const spaceId = localStorage.getItem('spaceId');
  return post(url.REMOVE_SPACE_MEMBER, { member_id: memberId }, { headers: { spaceId } });
}

// get user by id
export const getUserById = (userId) => {
  return get(`${url.GET_USER_BY_ID}/${userId}`);
}

// get user subscription status
export const getUserSubscriptionStatus = (userId) => {
  return get(`${url.GET_USER_SUBSCRIPTION_STATUS}?user_id=${userId}`);
}

// get user subscription details by admin
export const getUserSubscriptionById = (userId) => {
  return get(`${url.GET_USER_SUBSCRIPTION_BY_ID}/${userId}`);
}

// activate user subscription (admin only)
export const activateUserSubscription = (userId) => {
  return post(`${url.ACTIVATE_USER_SUBSCRIPTION}/${userId}/activate`);
}

// deactivate user subscription (admin only)
export const deactivateUserSubscription = (userId) => {
  return post(`${url.DEACTIVATE_USER_SUBSCRIPTION}/${userId}/deactivate`);
}

//invite customer
export const inviteCustomer = customer => post(url.INVITE_CUSTOMER, customer);

// get orders
export const getOrders = () => get(url.GET_ORDERS);

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order);

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order);

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } });

// get cart data
export const getCartData = () => get(url.GET_CART_DATA);

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS);

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer);

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer);

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } });

// get shops
export const getShops = () => get(url.GET_SHOPS);

// get wallet
export const getWallet = () => get(url.GET_WALLET);

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS);

// get invoices
export const getInvoices = () => get(url.GET_INVOICES);

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } });

// get project
export const getProjects = () => get(url.GET_PROJECTS);

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } });

// get tasks
export const getTasks = () => get(url.GET_TASKS);

// get contacts
export const getUsers = () => get(url.GET_USERS);

// add user
export const addNewUser = user => post(url.ADD_NEW_USER, user);

// update user
export const updateUser = user => put(url.UPDATE_USER, user);

// delete user
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } });

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project);

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project);

// delete user
export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } });

export const getUserProfile = () => get(url.GET_USER_PROFILE);

// get inboxmail
export const getInboxMails = () => get(url.GET_INBOX_MAILS);

// add inboxmail
export const addNewInboxMail = inboxmail =>
  post(url.ADD_NEW_INBOX_MAIL, inboxmail);

// delete inboxmail
export const deleteInboxMail = inboxmail =>
  del(url.DELETE_INBOX_MAIL, { headers: { inboxmail } });

// get starredmail
export const getStarredMails = () => get(url.GET_STARRED_MAILS);

// get importantmail
export const getImportantMails = () => get(url.GET_IMPORTANT_MAILS);

// get sent mail
export const getSentMails = () => get(url.GET_SENT_MAILS);

// get trash mail
export const getTrashMails = () => get(url.GET_TRASH_MAILS);

// get starredmail
export const getDraftMails = () => get(url.GET_DRAFT_MAILS);

// get dashboard charts data
export const getWeeklyData = () => get(url.GET_WEEKLY_DATA);
export const getYearlyData = () => get(url.GET_YEARLY_DATA);
export const getMonthlyData = () => get(url.GET_MONTHLY_DATA);

export const topSellingData = month =>
  get(`${url.TOP_SELLING_DATA}/${month}`, { params: { month } });

export const getEarningChartsData = month =>
  get(`${url.GET_EARNING_DATA}/${month}`, { params: { month } });

const getProductComents = () => get(url.GET_PRODUCT_COMMENTS);

const onLikeComment = (commentId, productId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}`, {
    params: { commentId, productId },
  });
};
const onLikeReply = (commentId, productId, replyId) => {
  return post(`${url.ON_LIKNE_COMMENT}/${productId}/${commentId}/${replyId}`, {
    params: { commentId, productId, replyId },
  });
};

const onAddReply = (commentId, productId, replyText) => {
  return post(`${url.ON_ADD_REPLY}/${productId}/${commentId}`, {
    params: { commentId, productId, replyText },
  });
};

const onAddComment = (productId, commentText) => {
  return post(`${url.ON_ADD_COMMENT}/${productId}`, {
    params: { productId, commentText },
  });
};

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
  getProductComents,
  onLikeComment,
  onLikeReply,
  onAddReply,
  onAddComment,
};
